import { FocusableOption, FocusMonitor, FocusOrigin } from '@angular/cdk/a11y';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  ViewEncapsulation,
  inject
} from '@angular/core';
import { Subject } from 'rxjs';
@Component({
    selector: '[sim-menu-item]',
    exportAs: 'uiMenuItem',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MenuItemComponent implements FocusableOption, OnDestroy, AfterViewInit {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);
  private readonly focusMonitor = inject(FocusMonitor);
  readonly _focused: Subject<MenuItemComponent> = new Subject<MenuItemComponent>();
  readonly _hovered: Subject<MenuItemComponent> = new Subject<MenuItemComponent>();

  @HostBinding('class')
  elementClass = 'ui-menu-item';

  @Input() disabled = false;
  @HostBinding('attr.disabled')
  get attrDisabled(): boolean | null {
    return this.disabled || null;
  }

  @HostBinding('attr.aria-disabled')
  get attrAriaDisabled(): string {
    return this.disabled.toString();
  }

  @HostListener('click', ['$event'])
  handleClick(event: MouseEvent): void {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  @HostListener('mouseenter', ['$event'])
  handleEnter(event: MouseEvent) {
    this._hovered.next(this);
  }

  ngAfterViewInit(): void {
    if (this.focusMonitor) {
      // Start monitoring the element so it gets the appropriate focused classes. We want
      // to show the focus style for menu items only when the focus was not caused by a
      // mouse or touch interaction.
      this.focusMonitor.monitor(this.elementRef, false);
    }
  }

  ngOnDestroy(): void {
    if (this.focusMonitor) {
      this.focusMonitor.stopMonitoring(this.elementRef);
    }

    this._focused.complete();
    this._hovered.complete();
  }

  focus(origin?: FocusOrigin, options?: FocusOptions): void {
    if (this.focusMonitor && origin) {
      this.focusMonitor.focusVia(this._getHostElement(), origin, options);
    }

    this._focused.next(this);
  }

  getLabel(): string {
    return '';
  }

  private _getHostElement(): HTMLElement {
    return this.elementRef.nativeElement;
  }
}
